import { useState, useEffect } from "react"
import RewardsAPI from "../../../services/API/Rewards"
import Loader from "../../Tools/Loader"

export default function Promo({indent}){

    const [code, setCode] = useState(false)

    useEffect(() => {

        const isPromo = indent?.items?.find(i => i.class === 'reward')?.reward?.type?.id === 'promo';

        if(isPromo){

            if(indent?.reference){

                setCode(indent.reference);

            }else{

                setCode('loading')

                RewardsAPI.getQuintessenceCode(indent.id)
                    .then(r => setCode(r.data.code))
                    .catch(e => setCode('Aucun code disponible 😔'))

            }
            

        }

    }, [indent])

    
    if(code === 'loading') return <Loader />;


    return code &&
    <>
        <p>Voici votre code :</p>

        <h3>{code}</h3>

        <p>Conservez-le précieusement 😉. Il vous a également été envoyé par email à l'adresse de votre compte LearnyLib.</p>

    </>
}